import Router from '@pages/pricing'
import CodesList from '@pages/pricing/list/list-codes'
import CodeView from '@pages/pricing/codes/view-code'

export default {
  path: 'pricing/',
  components: {
    default: Router,
  },

  children: [{
    path: '',
    redirect: () => ({
      name: 'codes-list',
    })
  }, {
    path: 'codes',
    name: 'codes-list',
    components: { 
      default: CodesList,
    },
  }, {
    path: ':id/infos/',
    name: 'code-view',
    components: { 
      default: CodeView,
    },
  }],
}